/**
 * Estado del proceso de aprobacion de cotizaciones. Solo aplica cuando el tenant
 * activa `quote_approval_flow` en su perfil; con el flujo apagado el estado se
 * sigue guardando pero no se muestra ni bloquea nada.
 */
export type QuoteApprovalStatus = "in_review" | "approved" | "blocked";

export const QUOTE_APPROVAL_IN_REVIEW = "in_review" as const;
export const QUOTE_APPROVAL_APPROVED = "approved" as const;
export const QUOTE_APPROVAL_BLOCKED = "blocked" as const;

const VALID_STATUSES: QuoteApprovalStatus[] = [
    QUOTE_APPROVAL_IN_REVIEW,
    QUOTE_APPROVAL_APPROVED,
    QUOTE_APPROVAL_BLOCKED,
];

/**
 * Las cotizaciones creadas antes del feature (y los hits de Meili que aun no se
 * reindexan) no traen el campo: se tratan como pendientes de revision.
 */
export function resolveQuoteApprovalStatus(raw: unknown): QuoteApprovalStatus {
    if (typeof raw === "string" && VALID_STATUSES.includes(raw as QuoteApprovalStatus)) {
        return raw as QuoteApprovalStatus;
    }
    return QUOTE_APPROVAL_IN_REVIEW;
}

export const QUOTE_APPROVAL_LABEL: Record<QuoteApprovalStatus, string> = {
    in_review: "En revision",
    approved: "Aprobada",
    blocked: "Bloqueada",
};

/** Formato que consume `highlightedColors` de ModelIndex. */
export const QUOTE_APPROVAL_COLORS: Record<QuoteApprovalStatus, { bg: string, text: string }> = {
    in_review: { bg: "#ffc107", text: "#212529" },
    approved: { bg: "#198754", text: "#fff" },
    blocked: { bg: "#dc3545", text: "#fff" },
};

/** Mensaje del alert cuando se intenta facturar una cotizacion que no esta aprobada. */
export const QUOTE_APPROVAL_BLOCK_MESSAGE: Record<Exclude<QuoteApprovalStatus, "approved">, string> = {
    in_review: "Esta cotizacion esta pendiente de revision. Debe aprobarse antes de facturar",
    blocked: "Esta cotizacion esta bloqueada y no puede facturarse",
};
